/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductItem
 */
export interface ProductItem {
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    productThumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    productNumber: string;
}

/**
 * Check if a given object implements the ProductItem interface.
 */
export function instanceOfProductItem(value: object): value is ProductItem {
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    return true;
}

export function ProductItemFromJSON(json: any): ProductItem {
    return ProductItemFromJSONTyped(json, false);
}

export function ProductItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductItem {
    if (json == null) {
        return json;
    }
    return {
        
        'productThumbnailUrl': json['productThumbnailUrl'],
        'productName': json['productName'],
        'productNumber': json['productNumber'],
    };
}

export function ProductItemToJSON(json: any): ProductItem {
    return ProductItemToJSONTyped(json, false);
}

export function ProductItemToJSONTyped(value?: ProductItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productThumbnailUrl': value['productThumbnailUrl'],
        'productName': value['productName'],
        'productNumber': value['productNumber'],
    };
}

